import useCurrentUser from 'hooks/useCurrentUser';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useGetIsPrivateDemoQuery } from 'services/api/demochat';
import { getClientPhoneIdentifier, setClientPhoneIdentifier } from 'utils/chatStorage';

import DemoChatPanel from './DemoChatPanel';

const Demochat = () => {
  const { companyIdentifier } = useParams<{ companyIdentifier: string }>();
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: privateDemoData } = useGetIsPrivateDemoQuery({
    companyIdentifier: companyIdentifier ?? '',
  });

  if (privateDemoData?.isPrivateDemo) {
    if (!currentUser || currentUser.id === 0) {
      navigate(`/sign-in?redirect=/demochat/${companyIdentifier}`);
    }
  }

  // Handle loadChat parameter from URL (for opening in new tab)
  useEffect(() => {
    const loadChatParam = searchParams.get('loadChat');
    if (loadChatParam && companyIdentifier) {
      setClientPhoneIdentifier(companyIdentifier, loadChatParam);
      searchParams.delete('loadChat');
      setSearchParams(searchParams, { replace: true });
      window.location.reload();
    }
  }, [searchParams, companyIdentifier]);

  const initialMessage = searchParams.get('message') || undefined;
  const autoStartChat = searchParams.get('autoStartChat') === 'true' && !!getClientPhoneIdentifier(companyIdentifier);

  const handleNavigateNewChat = useCallback(() => {
    navigate(`/demochat/${companyIdentifier}/newchat`);
  }, [navigate, companyIdentifier]);

  const handleSelectChat = useCallback(
    (phoneIdentifier: string) => {
      if (!companyIdentifier) return;
      setClientPhoneIdentifier(companyIdentifier, phoneIdentifier);
      navigate(`/demochat/${companyIdentifier}`, { replace: true });
      window.location.reload();
    },
    [navigate, companyIdentifier]
  );

  if (!companyIdentifier) return null;

  return (
    <DemoChatPanel
      companyIdentifier={companyIdentifier}
      onNavigateNewChat={handleNavigateNewChat}
      onSelectChat={handleSelectChat}
      initialMessage={initialMessage}
      autoStartChat={autoStartChat}
    />
  );
};

export default Demochat;
